import React from "react"
import CostImg from "./CostsImg"

export default function CostsMobile() {
  return (
    <div
      className="row justify-content-around align-items-center py-5"
      id="costs-mobile"
    >
      <div className="col-lg-6 pb-3">
        <CostImg />
      </div>
      <div className="col-lg-4 py-3">
        <h3 className="text-azure-blue">Lower Costs</h3>
        <p>
          Want to invest out of an IRA without all of the additional fees?
          Harvest Return's partnership with Prime Trust brings you IRAs at a
          fraction of the cost. No account opening fees, wire fees, or asset
          holdings fees. Only an annual fee of $195.
        </p>
      </div>
    </div>
  )
}
